import { useTranslation } from '@doccareplus/i18n';
import { Button, Card } from '@doccareplus/ui';

export function PortalLoadError({
  onRetry,
  compact = false,
}: {
  onRetry: () => void;
  compact?: boolean;
}) {
  const { t } = useTranslation('portal');

  return (
    <Card className={compact ? 'p-4' : 'p-5'} role="alert">
      <h2 className="text-[15px] font-bold">
        {t('errors.loadTitle', 'We could not load this information')}
      </h2>
      <p className="mt-1 text-[13px] leading-5 text-[var(--text-3)]">
        {t('errors.loadDescription', 'Check your connection and try again.')}
      </p>
      <Button className="mt-4" variant="outline" onClick={onRetry}>
        {t('actions.retry', 'Try again')}
      </Button>
    </Card>
  );
}
